<template>
  <v-app-bar
    app
    flat
    clipped-left
    height="70"
    color="#0F0F0F"
    class="nexus-header"
    :extended="loadingSystemUpdate"
    extension-height="4"
    v-if="!minimal"
  >
    <div class="d-flex align-center brand-zone" @click="goToRoute('/home')">
      <v-avatar size="40" class="hover-glow transition-all mr-3">
        <v-img :src="logo" contain></v-img>
      </v-avatar>
      
      <div class="d-flex flex-column">
        <span class="text-h6 font-weight-black white--text tracking-wider"
            >LEGOR<span class="brand-text">ERP</span></span
          >
      </div>
    </div>

    <v-spacer></v-spacer>
    <!-- Sin botón: mantiene el atajo ⌘K desde cualquier pantalla del contexto empresa -->
    <omni-bar :disparador="false" v-if="!esHome"></omni-bar>

    <div class="actions-wrapper d-flex align-center">
      <v-tooltip bottom v-if="puedeUsarAsistente">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon dark class="mx-1" style="background-color: #3a3b3c" v-bind="attrs" v-on="on" @click="abrirAsistente">
            <v-icon>mdi-creation</v-icon>
          </v-btn>
        </template>
        <span>Asistente: preguntá por tus números</span>
      </v-tooltip>
      <notificaciones-menu class="mx-1"></notificaciones-menu>
      
      <v-divider vertical inset class="grey darken-4 mx-3" style="height: 20px"></v-divider>
      
      <usuario-menu></usuario-menu>
    </div>

    <template v-if="loadingSystemUpdate" v-slot:extension>
      <v-progress-linear 
        indeterminate 
        color="blue" 
        background-color="transparent"
        height="2"
      ></v-progress-linear>
    </template>
  </v-app-bar>
</template>

<script>
import logo from "@/assets/bear-face-icon-2.png";
import { mapGetters, mapState } from "vuex";
import UsuarioMenu from "@/components/usuarios/usuario.menu.vue";
import NotificacionesMenu from "@/components/notificaciones/notificaciones.menu.vue";
import OmniBar from "@/components/empresa/OmniBar.vue";

export default {
  name: "EmpresaHeaderLayout",
  components: {
    UsuarioMenu,
    NotificacionesMenu,
    OmniBar,
  },
  props: {
    minimal: { type: Boolean, default: false },
  },
  data: () => ({
    logo,
  }),
  computed: {
    // En la home la paleta la monta el dashboard (barra grande): evitar dos instancias
    esHome() {
      return this.$route.name === "empresa.dashboard";
    },
    ...mapGetters(["loadingSystemUpdate"]),
    ...mapGetters("auth", ["puedeUsarAsistente"]),
    ...mapState("sucursales", ["configuracion"]),

  },
  methods: {
    abrirAsistente() {
      this.$updateBus.$emit("asistente:abrir", {});
    },
    goToRoute(route) {
      if (this.$route.path !== route) {
        this.$router.push(route).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
/* Estética Nexus: Cristal y bordes sutiles */
.nexus-header {
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
  z-index: 100;
}
.brand-text {
  background: linear-gradient(135deg, #ba6b30 0%, #f5a623 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Zona de Marca */
.brand-zone {
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 12px;
  transition: all 0.2s ease;
}
.brand-zone:hover {
  background: rgba(255, 255, 255, 0.03);
}

.hover-glow:hover {
  filter: drop-shadow(0 0 8px rgba(33, 150, 243, 0.5));
}

/* Cápsula de botones derecha */
.actions-wrapper {
  background: rgba(255, 255, 255, 0.03);
  padding: 4px 12px;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

/* Utilidades */
.uppercase { text-transform: uppercase; }
.line-height-1 { line-height: 1.1; }
.letter-spacing-1 { letter-spacing: 1px !important; }
.transition-all { transition: all 0.3s ease; }

/* Limpieza de slots de Vuetify */
::v-deep .v-toolbar__extension {
  padding: 0 !important;
  background-color: transparent !important;
}
</style>